var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0011 15.5358V16.4557C26.0003 17.7689 25.7407 19.0692 25.2374 20.2821C24.7342 21.4951 23.9971 22.597 23.068 23.525C22.1389 24.4531 21.0359 25.189 19.8224 25.6908C18.6088 26.1926 17.3085 26.4505 15.9952 26.4497C13.3432 26.4481 10.8001 25.3932 8.9259 23.517C7.05169 21.6407 5.99977 19.0967 6.0011 16.4447C6.00176 15.1314 6.26107 13.8311 6.76428 12.618C7.2675 11.405 8.00456 10.3029 8.93372 9.37476C9.86287 8.44662 10.9657 7.71062 12.1793 7.20874C13.3929 6.70686 14.6937 6.44892 16.007 6.44971C17.4073 6.45064 18.7918 6.74564 20.0709 7.31568",
    stroke: "#04B014",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0011 8.45557L16.0011 18.4656L13.0011 15.4656",
    stroke: "#04B014",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.0ae04d514b8def09ad26315efbb837ab.svg";
export { ForwardRef as ReactComponent };